import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type ECommerceUserAddressInfoRequest } from '../types/apiRequest'
import { type ECommerceUserAddressInfoResponse } from '../types/apiResponse'
import { type ECommerceApis } from '../types/apis'

const { useRequest } = createRequestHelper<ECommerceApis['get']['userAddressInfo'], ECommerceUserAddressInfoResponse, ECommerceUserAddressInfoRequest>({
  client: 'eCommerce',
  key: (params) => {
    if (!params) return null
    const { country_code, project_code } = params
    if (!country_code || !project_code) {
      console.warn('[useApiUserAddressInfo] country_code, project_code are required!')
      return null
    }
    return `/user/address_info?${queryStringify({
      country_code,
      project_code,
    })}`
  },
  isImmutable: true,
})

/** @deprecated */
export const useApiUserAddressInfo = useRequest
